import { RSAA } from 'redux-api-middleware';
import * as types from "../types/index";
import { API_ENDPOINT, AUTH_HEADERS } from '../../config/ApiConstants';


export function resend_user_invite_Action(token, userId, groupId,organisationId) {
    // var searchbyname = data ? data : "";
    // console.log("data Action--",data);
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/organisation/group/${groupId}/resend-user-invite/${userId}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                'Authorization': `Bearer ${token}`,
                organisationId: organisationId,
                },

            types: [
                types.RESEND_USER_INVITE_REQUEST,
                types.RESEND_USER_INVITE_RECEIVE, {
                    type: types.RESEND_USER_INVITE_FAILURE,
                    meta: (action, state, res) => {
                        return (action, state, res);
                    }
                }]
        }
    }
}

export const reset_resned_user_invite_Action = () => {
    return {
        type: types.RESET_RESEND_USER_INVITE,
        payload: null
    }
};
